import React, { useEffect } from 'react'
import Select from '@material-ui/core/Select'
import { SelectProps } from '@material-ui/core/Select/Select'
import { primaryBlue } from '../../styles/material-ui-theme-v2'
import { ReactComponent as SelectArrowIcon } from '../../assets/v3/icons/select-arrow.svg'
import { getWidthOfText } from '../YumManualEntryForm/YumManualEntryForm'
import { Input } from '@material-ui/core'
import { isRtl } from '../../i18nInit'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      verticalAlign: 'unset',
    },
    select: {
      textTransform: 'none',
      fontSize: '13px',

      borderRadius: '8px',
      height: '32px',
      border: 'none',
      '&:focus': {
        borderRadius: '8px',
      },
    },
  }),
)

export default function YumMediumSelect({ children, ...props }: SelectProps) {
  const classes = useStyles()
  const [width, setWidth] = React.useState(50)

  const updateTextSize = () => {
    // @ts-ignore
    const text = children?.find((c: { props: { value: any } }) => c?.props?.value === props.value)?.props?.children
    if (text) {
      setWidth(getWidthOfText(text, '700', '13px'))
    }
  }

  useEffect(() => {
    updateTextSize()
  }, [])

  /*componentDidUpdate(prevProps: Readonly<SelectProps>, prevState: Readonly<{}>, snapshot?: any) {
    if (props.value !== prevProps.value) {
      updateTextSize()
    }
  }*/

  const onChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    // @ts-ignore
    const text = event.target.options[event.target.selectedIndex].text
    if (text) setWidth(getWidthOfText(text, '700', '13px'))
    // @ts-ignore
    if (props.onChange) props.onChange(event)
  }

  const outlined = props.variant === 'outlined'

  return (
    <Select
      {...props}
      className={classes.root}
      onChange={onChange}
      native
      IconComponent={(props) => (
        <SelectArrowIcon
          {...props}
          style={{
            top: 'auto',
            left: isRtl ? '11px' : 'auto',
            right: isRtl ? 'auto' : '11px',
            color: outlined ? primaryBlue : 'white',
          }}
        />
      )}
      style={{
        ...props.style,
        width: width + 39 + 'px',
        maxWidth: '100%',
        padding: isRtl ? '0 24px 0 10px !important' : '0 10px 0 24px !important',
      }}
      inputProps={{
        className: classes.select,
        style: {
          paddingRight: isRtl ? 10 : 24,
          paddingLeft: isRtl ? 24 : 10,
        },
      }}
      input={<Input />}
      disableUnderline
    >
      {children}
    </Select>
  )
}
